// OK 17/10/2024

import { getCurrentUser } from "../apis/auth";

export async function rootLoader() {
    return getCurrentUser();
}